<template>
  <Draggable
    v-model="media"
    class="grid"
    handle=".handle">
    <MediaBox
      v-for="(medium, i) in media"
      :key="medium.id"
      :medium="medium"
      :tabindex="medium.type === 'divider' ? false : i + 1"
    />
  </Draggable>
</template>

<script>
import { mapActions } from 'vuex'
import MediaBox from '@/components/MediaBox'
import Draggable from 'vuedraggable'

export default {
  components: {
    MediaBox,
    Draggable
  },
  props: {
    uid: String
  },
  mounted() {
    this.$store.dispatch('bindMedia', this.uid)
  },
  computed: {
    media: {
      get() {
        if (!this.query) {
          return this.$store.state.media
        } else {
          return this.$store.getters.searchedMedia
        }
      },
      set(val) {
        this.reorderMedia(val)
      }
    },
    query() {
      return this.$store.state.query
    }
  },
  methods: {
    reorderMedia(media) {
      const vm = this
      media.forEach((medium, index) => {
        vm.updateMedia({medium: {order: index}, id: medium.id})
      })
    },
    ...mapActions([
      'updateMedia'
    ])
  }
}
</script>

<style>

</style>